import React from 'react';
import Select from 'react-select';

const border = '1px solid var(--color-border)';
const colorDark = 'var(--color-grey-dark-1)';
const colorWhite = 'var(--color-white)';
const backgroundColorGrey = 'var(--background-color-grey)';
const customStyles = {
    container: (provided, state) => ({
        ...provided,
        width: '100%',
        height: '100%'
    }),
    indicatorsContainer: () => ({
        display: 'none'
    }),
    control: () => ({
        border: 'none',
        borderRadius: 0,
        borderBottom: `${border}`,
        height: '90%'
    }),
    valueContainer: () => ({
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContainer: 'center',
        alignItems: 'center'
    }),
    placeholder: () => ({
        color: '#999',
        fontSize: '1.3rem',
        lineHeight: 1,
        position: 'absolute',
        top: '-.3rem'
    }),
    singleValue: (provided, state) => ({
        ...provided,
        fontSize: '1.6rem',
        color: `${colorDark}`
    }),
    menu: () => ({
        position: 'absolute',
        backgroundColor: `${colorWhite}`,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        borderRadius: '4px',
        overflow: 'scroll',
        height: '16.5rem',
        width: '28rem',
        padding: '.8rem 0',
        left: 0,
        top: '6rem',
        zIndex: 555
    }),
    option: (provided, state) => ({
        ...provided,
        lineHeight: '3.8rem',
        padding: '0 1.6rem',
        color: `${colorDark}`,
        fontSize: '1.3rem',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: `${backgroundColorGrey}`
        },
        '&:focus': {
            backgroundColor: `${backgroundColorGrey}`
        }
    })
}

const SearchSelectMenu = (props) => 
        <Select 
            value={props.value}
            options={props.options} 
            onChange={props.onChange} 
            placeholder={props.placeholder}
            styles={customStyles} />;
    

export default SearchSelectMenu;


// WEBPACK FOOTER //
// ./src/components/UI/SearchSelectMenu/SearchSelectMenu.js